/**
 * Pedido de saída já gravado: a forma e a condição salvas ficam,
 * enquanto o cliente do pedido não mudar.
 * Pedido novo (sem id) continua recebendo o padrão do cadastro do cliente.
 *
 * @param {{ boundCustomerId: string|null }} state Estado do campo nesta abertura do formulário.
 * @param {unknown} orderId Id do pedido já gravado. Vazio em pedido novo.
 * @param {unknown} customerId Cliente que disparou a carga.
 * @returns {boolean} true = não substituir o valor que já está no pedido.
 */
/**
 * Id do pedido gravado no mesmo formulário do campo (ex.: order.payment_method → order.id).
 * @param {{ getId?: () => string }} field
 * @param {{ getItem?: (key: string) => string|null }} [storage]
 * @returns {string|null}
 */
export function readFormOrderId(field, storage = globalThis.sessionStorage)
{
	const own = typeof field?.getId === 'function' ? String(field.getId()) : '';
	const dot = own.lastIndexOf('.');
	if (dot <= 0 || typeof storage?.getItem !== 'function')
		return null;
	return storage.getItem(`${own.slice(0, dot)}.id`);
}

export function keepSavedOrderPayment(state, orderId, customerId)
{
	const orderRaw = orderId == null ? '' : String(orderId).trim();
	const orderNum = Number(orderRaw);
	const isExisting = orderRaw !== '' && Number.isFinite(orderNum) && orderNum > 0;
	if (!isExisting)
		return false;
	const customerNum = Number(customerId);
	if (!Number.isFinite(customerNum) || customerNum <= 0)
		return false;
	const next = String(customerNum);
	if (state.boundCustomerId == null)
	{
		state.boundCustomerId = next;
		return true;
	}
	if (state.boundCustomerId === next)
		return true;
	state.boundCustomerId = next;
	return false;
}
